import { temAcesso } from '@/shared/auth/temAcesso'

const Filiais = () => import('./Filiais.vue')
const FiliaisForm = () => import('./FilialForm.vue')

export default {
    path: 'filiais',
    name: 'Filiais',
    component: Filiais,
    beforeEnter: (to, from, next) => {
        if (temAcesso('ADMIN-FILIAIS-00')) {
            next()
        }
    },
    children: [
        {
            path: 'inserir',
            name: 'Filiais_Inserir_Filial',
            component: FiliaisForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ADMIN-FILIAIS-01')) {
                    next()
                }
            }
        },
        {
            path: 'atualizar/:filialId',
            name: 'Filiais_Atualizar_Filial',
            component: FiliaisForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('ADMIN-FILIAIS-01')) {
                    next()
                }
            }
        },
    ]
}